const AppVersion = {"version": "v1.4.0-rc.9"}; export default AppVersion;